import { isAnalyticsTrackingEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';

import { EVENT_ORIGIN_CLIENT, EVENT_ORIGIN_KEY } from '../eventOrigin';

import { getExperimentProps } from './getExperimentProps';
import { shouldSuppressProductAnalytics } from './suppressProductAnalytics';

declare const window: Window & {
  analytics?: SegmentAnalytics.AnalyticsJS;
};

export function trackRouteChange({
  url,
  referer,
  pathPattern,
  refererPathPattern,
}: {
  url: string;
  referer: string | undefined;
  pathPattern: string;
  refererPathPattern: string | undefined;
}) {
  if (isAnalyticsTrackingEnabled() && !shouldSuppressProductAnalytics()) {
    window.analytics?.page?.({
      url,
      referer,
      pathPattern,
      refererPathPattern,
      ...getExperimentProps(),
      [EVENT_ORIGIN_KEY]: EVENT_ORIGIN_CLIENT,
    });
  }
}
